import { render } from "./allcourse.vue?vue&type=template&id=fccbae3e&scoped=true&ts=true"
import script from "./allcourse.vue?vue&type=script&lang=ts"
export * from "./allcourse.vue?vue&type=script&lang=ts"

import "./allcourse.vue?vue&type=style&index=0&id=fccbae3e&lang=less"
import "./allcourse.vue?vue&type=style&index=1&id=fccbae3e&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fccbae3e"]])

export default __exports__